var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadReceiptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.17 15.4998H13.84V11.4998C13.8374 11.3256 13.7671 11.1592 13.6438 11.036C13.5206 10.9128 13.3542 10.8424 13.18 10.8398H9.78C9.60655 10.8449 9.44158 10.916 9.31888 11.0387C9.19618 11.1614 9.12503 11.3264 9.12 11.4998V15.4998H6.83C6.74584 15.4997 6.66479 15.5317 6.60345 15.5893C6.54211 15.6469 6.5051 15.7258 6.5 15.8098C6.50128 15.8997 6.53709 15.9857 6.6 16.0498L11.5 20.8798L16.41 16.0498C16.4692 15.9899 16.5025 15.9091 16.5025 15.8248C16.5025 15.7406 16.4692 15.6597 16.41 15.5998C16.3796 15.5668 16.3424 15.5407 16.301 15.5235C16.2596 15.5062 16.2149 15.4981 16.17 15.4998Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 21.8906H6.5V23.8906H16.5V21.8906Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8.5H15.5V0.5H4C3.07174 0.5 2.1815 0.868749 1.52513 1.52513C0.868749 2.1815 0.5 3.07174 0.5 4V24C0.5 24.9283 0.868749 25.8185 1.52513 26.4749C2.1815 27.1313 3.07174 27.5 4 27.5H19C19.9283 27.5 20.8185 27.1313 21.4749 26.4749C22.1313 25.8185 22.5 24.9283 22.5 24V8.5ZM22.5 8.5L15.5 0.5",
    stroke: "black",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadReceiptIcon);
export default __webpack_public_path__ + "static/media/DownloadReceiptIcon.2830d3afb368324ac51c5b900f47b5a6.svg";
export { ForwardRef as ReactComponent };